<script>
  // A Moment's media: the video (playable in the lightbox) or the main photo, plus
  // the selfie — so a moderator can judge a post from the list.
  // `value` is the server's media hash ({ main_url, selfie_url, thumbnail_url, video_url }).
  // Grid card figures set `column.fill` to stretch it to the card's square; there the selfie is
  // inset in the corner, while a table row puts it beside the main photo (an inset would cover it).
  import ClickableImage from '../../lightbox/clickable_image.svelte'
  import ClickableVideo from '../../lightbox/clickable_video.svelte'

  let { value, column = {} } = $props()

  const media = $derived(value || {})
  const fill = $derived(!!column.fill)
  const mainClass = $derived(fill ? 'h-full w-full object-contain' : 'h-14 w-14 object-contain bg-base-200 rounded-box')
  const selfieClass = $derived(
    fill ? 'h-16 w-16 object-cover rounded-box border-2 border-base-100' : 'h-8 w-8 object-cover rounded-box border border-base-100'
  )
  const items = $derived(
    [
      media.video_url ? { type: 'video', url: media.video_url } : media.main_url ? { type: 'image', url: media.main_url } : null,
      media.selfie_url ? { type: 'image', url: media.selfie_url, title: 'Selfie' } : null
    ].filter(Boolean)
  )
</script>

<div class={fill ? 'relative inline-block h-full w-full' : 'inline-flex items-end gap-1'}>
  {#if media.video_url}
    <ClickableVideo url={media.video_url} thumbnailUrl={media.thumbnail_url} thumbClass={mainClass} buttonClass={fill ? 'h-full w-full' : ''} {items} />
  {:else}
    <ClickableImage url={media.main_url || media.thumbnail_url} thumbClass={mainClass} buttonClass={fill ? 'h-full w-full' : ''} {items} />
  {/if}
  {#if media.selfie_url}
    <div class={fill ? 'absolute bottom-2 right-2' : ''}>
      <ClickableImage url={media.selfie_url} title="Selfie" thumbClass={selfieClass} {items} />
    </div>
  {/if}
</div>
